import { render, staticRenderFns } from "./GalaxyPreview.vue?vue&type=template&id=6818dbc8&"
import script from "./GalaxyPreview.vue?vue&type=script&lang=js&"
export * from "./GalaxyPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports